module.exports = __webpack_public_path__ + "img/ksh2.a7f26c00.png";